import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  NgZone,
  OnDestroy,
  inject,
} from '@angular/core';

/**
 * Fades the edges of a horizontally scrolling row (tabs on narrow screens)
 * where more content is hidden: `scroll-fade-start` and `scroll-fade-end`
 * on the element, styled in overrides/_components.scss. The selected tab is
 * scrolled into view once.
 */
@Directive({
  selector: '[appScrollFade]',
  standalone: true,
})
export class ScrollFadeDirective implements AfterViewInit, OnDestroy {
  private element = inject<ElementRef<HTMLElement>>(ElementRef);
  private zone = inject(NgZone);
  private observer: ResizeObserver | null = null;

  ngAfterViewInit() {
    const element = this.element.nativeElement;
    if (typeof ResizeObserver !== 'undefined') {
      this.zone.runOutsideAngular(() => {
        this.observer = new ResizeObserver(() => this.update());
        this.observer.observe(element);
      });
    }
    setTimeout(() => {
      element
        .querySelector('[aria-selected="true"]')
        ?.scrollIntoView?.({ block: 'nearest', inline: 'nearest' });
      this.update();
    });
  }

  ngOnDestroy() {
    this.observer?.disconnect();
  }

  @HostListener('scroll')
  update() {
    const element = this.element.nativeElement;
    const max = element.scrollWidth - element.clientWidth;
    element.classList.toggle('scroll-fade-start', element.scrollLeft > 1);
    element.classList.toggle(
      'scroll-fade-end',
      max > 1 && element.scrollLeft < max - 1
    );
  }
}
